if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);

        const mediaId = opener.getAttribute('data-media-id');

        // Wait for modal content to be rendered
        setTimeout(() => {
          const container = this.querySelector('.product-media-modal__content');
          if (!container) return;

          // Hide all other media inside modal
          container.querySelectorAll('[data-media-id]').forEach(el => {
            if (el.getAttribute('data-media-id') === mediaId) {
              el.style.display = 'block';
            } else {
              el.style.display = 'none';
            }
          });
        }, 50);
      }
    }
  );
}
